const settings: ClientSettings = {
  name: "Tafácil",
  benefitCardName: "Cartão Benefício",
  theme: {
    token: {
      // Figma "Primary - Tafácil" e "Secundary - Tafácil".
      colorPrimary: "#5C2482",
      colorHighlight: "#E74E0F",
    },
    components: {
      // O padrão do antd some sobre o card escuro dos steps.
      Button: {
        colorBgContainerDisabled: "#E6E9ED",
        colorTextDisabled: "#8A92A6",
        borderColorDisabled: "#D9DDE3",
      },
    },
  },
  assets: {
    background: "/somapay-login-bg.jpg",
    logo: "/somapay-logo-dark.png",
    logo_header: "/somapay-logo.png",
    favicon: "/somapay-favicon.svg",
    card: "/somapay-card.png",
    consignedCard: "/somapay-card.png",
  },
};

export default settings;
